var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lang-switcher"},[_c('el-select',{model:{value:(_vm.selectedPane),callback:function ($$v) {_vm.selectedPane=$$v},expression:"selectedPane"}},_vm._l((_vm.locales),function(locale){return _c('el-option',{key:locale.code,attrs:{"label":locale.code.toUpperCase(),"value":locale.code}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }